import { schema } from 'normalizr';
import { blacklistEntity } from '../../models/blacklist/blacklist.schema';
import { memberSchema } from '../../models/member';
import { pictureSchema } from '../../models/picture';

export const blacklistSchema = new schema.Object({
  data: [blacklistEntity],
  included: new schema.Array(
    {
      member: memberSchema,
      picture: pictureSchema,
    },
    'type'
  ),
});
